import { createContext, useContext, useEffect, useState } from "react";
import { StatusCode } from "../components/Alert.tsx";
import JournalsController from "../controllers/JournalsController.ts";
import FormatDate from "../models/helpers/formatDate.ts";
import { JournalSummary } from "../models/journals/journalSummary";
import { JournalSummarySearchParam } from "../models/searchParams/journalSearchParam";
import { useAlert } from "./alertProvider.tsx";

type JournalStatisticsContextType = {
    isLoaded?: boolean;
    days: JournalSummary[];

    daysSearchParam: JournalSummarySearchParam;
    setDaysSearchParam: (param: JournalSummarySearchParam) => void;
};

const JournalStatisticsContext = createContext<JournalStatisticsContextType>({} as JournalStatisticsContextType);

export const JournalStatisticsContextProvider = ({ children }: { children: any }) => {
    const { showAlert } = useAlert();
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [days, setDays] = useState<JournalSummary[]>([]);
    let dateFrom = new Date();
    let dateTo = new Date();
    dateFrom.setDate(dateFrom.getDate() - dateFrom.getDay() + 1);
    dateTo.setDate(dateFrom.getDate() + 6);
    const [daysSearchParam, setDaysSearchParam] = useState<JournalSummarySearchParam>({ dateFrom, dateTo } as JournalSummarySearchParam);

    const fetchDays = async () => {
        try {
            const result = await JournalsController.getSummary(daysSearchParam);
            if (result.notificationStatus != StatusCode.success) {
                showAlert(result.notificationStatus, result.notificationMessage);
                return;
            }
            var days: JournalSummary[] = result.journalSummaries.map(x => ({ percent: x.percent, dateTime: new Date(x.dateTime), calories: x.calories, protein: x.protein, carbohydrates: x.carbohydrates, totalFat: x.totalFat } as JournalSummary)).sort((a, b) => a.dateTime - b.dateTime);
            var generatedDays: JournalSummary[] = [];
            for (var forDate: Date = daysSearchParam.dateFrom!; forDate <= daysSearchParam.dateTo!; forDate.setDate(forDate.getDate() + 1)) {
                const existingDay = days.find((day) => FormatDate(day.dateTime) === FormatDate(forDate));
                if (existingDay) {
                    generatedDays.push(existingDay);
                } else {
                    generatedDays.push({ percent: 0, dateTime: new Date(forDate), calories: 0, protein: 0, carbohydrates: 0, totalFat: 0 } as JournalSummary);
                }
            }
            setDays(generatedDays);
            setIsLoaded(true);
        } catch (error) {
            console.error('Error fetching journal summaries:', error);
        }
    }
    useEffect(() => {
        fetchDays();
    }, [daysSearchParam]);

    const context: JournalStatisticsContextType = {
        isLoaded,
        days,

        daysSearchParam,
        setDaysSearchParam
    }

    return (
        <JournalStatisticsContext.Provider value={context}>
            {children}
        </JournalStatisticsContext.Provider>
    )
}

export const useJournalStatisticsContext = () => useContext(JournalStatisticsContext)
